import React from 'react'

const Jva_set = () => {
    return (
        <div className='container'>
            <div class="entry-content blog-post__contents">
      
      <p>Java Set is a collection of elements (Or objects) that contains no duplicate elements. Java Set is an interface
            that extends Collection interface. Unlike List, Java Set is NOT an ordered collection, it’s elements does
            NOT have a particular order. Java Set does <strong>NOT</strong> provide a control over the position where
            you can insert an element. You cannot access elements by their index and also search elements in the list.
      </p>
    
      <div id="toc_container" class="no_bullets contracted">
            <p class="toc_title">Table of Contents <span class="toc_toggle"></span></p>
            <ul class="toc_list" >
                  <li><a href="#java-set"><span class="toc_number toc_depth_1">1</span> Java Set</a></li>

                  <li><a href="#java-set-methods"><span class="toc_number toc_depth_1">3</span> Java Set Methods</a>
                  </li>
                  <li><a href="#java-array-to-set"><span class="toc_number toc_depth_1">4</span> Java Array to Set</a>
                  </li>
                  <li><a href="#java-set-to-array"><span class="toc_number toc_depth_1">5</span> Java Set to Array</a>
                  </li>
                  <li><a href="#java-set-sorting"><span class="toc_number toc_depth_1">6</span> Java Set Sorting</a>
                  </li>
                  <li><a href="#java-set-common-operations"><span class="toc_number toc_depth_1">7</span> Java Set
                              Common Operations</a></li>
                  <li><a href="#java-set-iterator"><span class="toc_number toc_depth_1">8</span> Java Set Iterator</a>
                  </li>
                  <li><a href="#java-set-to-stream"><span class="toc_number toc_depth_1">9</span> Java Set to Stream</a>
                  </li>
                  <li><a href="#java-se-9-set"><span class="toc_number toc_depth_1">10</span> Java SE 9 Set</a></li>
            </ul>
      </div>
      <h3><span id="java-set">Java Set</span></h3>
      <p>In this section, we will discuss some of the important points about Java Set:</p>
      <ul>
            <li>Java Set interface is a member of the Java Collections Framework.</li>
            <li>Unlike List, Set <strong>DOES NOT</strong> allow you to add duplicate elements.</li>
            <li>Set allows you to add at most one null element only.</li>
            <li>Set interface got one default method in Java 8: spliterator.</li>
            <li>Unlike List and arrays, Set does NOT support indexes or positions of it’s elements.</li>
            <li>Set supports Generics and we should use it whenever possible. Using Generics with Set will avoid
                  ClassCastException at runtime.</li>
            <li>We can use Set interface implementations to maintain unique elements.</li>
      </ul>
      <h3><span id="java-set-class-diagram">Java Set Class Diagram</span></h3>
      <p>Java Set interface extends Collection interface. Collection interface extends Iterable interface. Some of the
            frequently used Set implementation classes are HashSet, LinkedHashSet, TreeSet, CopyOnWriteArraySet and
            ConcurrentSkipListSet. AbstractSet provides a skeletal implementation of the Set interface to reduce the
            effort in implementing Set.</p>
      <p></p>
      <h3><span id="java-set-methods">Java Set Methods</span></h3>
      <p>In this section we will discuss some of the useful Java Set methods:</p>
     
      <ul>
            <li>int size(): to get the number of elements in the Set.</li>
            <li>boolean isEmpty(): to check if Set is empty or not.</li>
            <li>boolean contains(Object o): Returns true if this Set contains the specified element.</li>
            <li>Iterator iterator(): Returns an iterator over the elements in this set. The elements are returned in no
                  particular order.</li>
            <li>Object[] toArray(): Returns an array containing all of the elements in this set. If this set makes any
                  guarantees as to what order its elements are returned by its iterator, this method must return the
                  elements in the same order.</li>
            <li>boolean add(E e): Adds the specified element to this set if it is not already present (optional
                  operation).</li>
            <li>boolean remove(Object o): Removes the specified element from this set if it is present (optional
                  operation).</li>
            <li>boolean removeAll(Collection c): Removes from this set all of its elements that are contained in the
                  specified collection (optional operation).</li>
            <li>boolean retainAll(Collection c): Retains only the elements in this set that are contained in the
                  specified collection (optional operation).</li>
            <li>void clear(): Removes all the elements from the set.</li>
            <li>Iterator iterator(): Returns an iterator over the elements in this set.</li>
      </ul>
      <h3><span id="java-array-to-set">Java Array to Set</span></h3>
      <p>Unlike List, We cannot convert a Java Set into an array directly as it’s NOT implemented using an Array.<br/>
            So We cannot use Arrays class to get the view of array as set. We can follow another approach. We can
            convert an array into List using Arrays.asList() method, then use it to create a Set. By using this
            approach, we can covert a Java Array to Set in two ways. Let us discuss them one by one using one simple
            example.</p>
      <p><strong>Approach-1</strong><br/>
            In this approach, first We need to create a List using given array and use it to create a Set as shown
            below.</p>
      <pre className='containers'><code class="hljs cs"><div class="re_clip-board" ></div> <br />
import java.util.*; <br />
 <br />
<span class="keywords">public</span> <span class="keywords">class</span> <span class="hljs-title">ArrayToSet</span> &#123; <br />
<span class="hljs-function"><span class="keywords">public</span> <span class="keywords">static</span> <span class="keywords">void</span> <span class="hljs-title">main</span>(<span class="hljs-params">String[] args</span>) </span>&#123; <br />
       <br />
String[] vowels = &#123;<span class="plain">"a"</span>,<span class="plain">"e"</span>,<span class="plain">"i"</span>,<span class="plain">"o"</span>,<span class="plain">"u"</span>&#125;; <br />
       <br />
Set&lt;String&gt; vowelsSet = <span class="keywords">new</span> HashSet&gt;(Arrays.asList(vowels)); <br />
System.<span class="keywords">out</span>.println(vowelsSet); <br />
 <br />
<span class="comment">/** <br />
 * Unlike List, Set is NOt backed by array,  <br />
 * so we can do structural modification without any issues. <br />
 */</span> <br />
vowelsSet.<span class="keywords">remove</span>(<span class="plain">"e"</span>); <br />
System.<span class="keywords">out</span>.println(vowelsSet); <br />
vowelsSet.clear(); <br />
System.<span class="keywords">out</span>.println(vowelsSet); <br />
&#125; <br />
&#125; <br />
</code></pre> <br />
      <p><strong>Approach-2</strong><br/>
            In this approach, we do NOT use intermediate List to create a Set from an Array. First create an empty
            HashSet, then use Collections.addAll() to copy array elements into the given Set as shown below.</p>
      <pre className='containers'><code class="hljs cs"><div class="re_clip-board" ></div>
import java.util.*;

<span class="keywords">public</span> <span class="keywords">class</span> <span class="hljs-title">ArrayToSet2</span> &#123;
<span class="hljs-function"><span class="keywords">public</span> <span class="keywords">static</span> <span class="keywords">void</span> <span class="hljs-title">main</span>(<span class="hljs-params">String[] args</span>) </span>&#123; <br />
       <br />
String[] vowels = &#123;<span class="plain">"a"</span>,<span class="plain">"e"</span>,<span class="plain">"i"</span>,<span class="plain">"o"</span>,<span class="plain">"u"</span>&#125;; <br />
       <br />
Set&lt;String&gt; vowelsSet = <span class="keywords">new</span> HashSet&lt;&gt;(); <br />
Collections.addAll(vowelsSet, vowels);  <br />
System.<span class="keywords">out</span>.println(vowelsSet); <br />
 <br />
<span class="comment">/**  <br />
 * Unlike List, Set is NOt backed by array,  <br />
 * so we can do structural modification without any issues. <br />
 */</span> <br />
vowelsSet.<span class="keywords">remove</span>(<span class="plain">"e"</span>); <br />
System.<span class="keywords">out</span>.println(vowelsSet); <br />
vowelsSet.clear(); <br />
System.<span class="keywords">out</span>.println(vowelsSet); <br />
&#125; <br />
&#125; <br />
</code></pre> <br />
      <p><strong>Output:-</strong><br/> <br />
            When we run above two programs, we will get the same output as shown below.</p> <br />
      <pre className='output'><code class="hljs json"><div class="re_clip-board" ></div> <br />
[a, e, u, i, o] <br />
[a, u, i, o] <br />
[] <br />
</code></pre>
      <h3><span id="java-set-to-array">Java Set to Array</span></h3>
      <p>In this section, we will write a program to convert a Set of Strings into an Array of String using
            Set.toArray() method as shown below.</p>
     
      <pre className='containers'><code class="hljs cs"><div class="re_clip-board" ></div>
import java.util.*; <br />
 <br />
<span class="keywords">public</span> <span class="keywords">class</span> <span class="hljs-title">SetToArray</span> &#123; <br />
<span class="hljs-function"><span class="keywords">public</span> <span class="keywords">static</span> <span class="keywords">void</span> <span class="hljs-title">main</span>(<span class="hljs-params">String[] args</span>) </span>&#123; <br />
Set&lt;String&lt; vowelsSet = <span class="keywords">new</span> HashSet&lt;&gt;(); <br />
 <br />
<span class="comment">// add example</span> <br />
vowelsSet.<span class="keywords">add</span>(<span class="plain">"a"</span>); <br />
vowelsSet.<span class="keywords">add</span>(<span class="plain">"e"</span>); <br />
vowelsSet.<span class="keywords">add</span>(<span class="plain">"i"</span>); <br />
vowelsSet.<span class="keywords">add</span>(<span class="plain">"o"</span>); <br />
vowelsSet.<span class="keywords">add</span>(<span class="plain">"u"</span>); <br />
       <br />
<span class="comment">//convert Set to Array</span> <br />
String strArray[] = vowelsSet.toArray(<span class="keywords">new</span> String[vowelsSet.size()]); <br />
System.<span class="keywords">out</span>.println(Arrays.toString(strArray));  <br />
&#125; <br />
&#125; <br />
</code></pre> <br />
      <p><strong>Output:-</strong><br/> <br />
            When we run above program, we will get the following output as shown below.</p>
      <pre className='output'><code class="hljs json"><div class="re_clip-board" ></div>
[a, e, u, i, o]
</code></pre>
      <h3><span id="java-set-sorting">Java Set Sorting</span></h3>
      <p>As we know, Set (HashSet) does NOT support sorting elements directly. It stores and display it’s elements in
            random order.</p>
      <p>However, we have some approaches to sort it’s elements as shown below:</p>
      <pre className='containers'><code class="hljs cs"><div class="re_clip-board" ></div> <br />
import java.util.*; <br />
 <br />
<span class="keywords">public</span> <span class="keywords">class</span> <span class="hljs-title">SetSortingExample</span> &#123; <br />
 <br />
<span class="hljs-function"><span class="keywords">public</span> <span class="keywords">static</span> <span class="keywords">void</span> <span class="hljs-title">main</span>(<span class="hljs-params">String[] args</span>) </span>&#123; <br />
      Set&lt;Integer&gt; intsSet = <span class="keywords">new</span> HashSet&lt;&gt;(); <br />
      Random random = <span class="keywords">new</span> Random(); <br />
      <span class="keywords">for</span> (<span class="keywords">int</span> i = <span class="plain">0</span>; i  &#123;<span class="keywords">return</span> (o2-o1);&#125;); <br />
      System.<span class="keywords">out</span>.println(<span class="plain">"Reverse Sorting: "</span> + intsList2); <br />
 <br />
      <span class="comment">// Approach-3</span> <br />
      Set&lt;Integer&gt; sortedSet = <span class="keywords">new</span> TreeSet&lt;&gt;(intsSet); <br />
      System.<span class="keywords">out</span>.println(<span class="plain">"Sorted Set: "</span> + sortedSet); <br />
&#125; <br />
&#125; <br />
</code></pre> <br />
      <p><strong>Output:-</strong><br/>
            When we run above program, we will see the following output.</p>
      <pre><code class="output"><div class="re_clip-board" ></div>
<span class="hljs-selector-attr">[560, 864, 176, 657, 135, 103, 40, 123, 555, 589]</span> <br />
<span class="hljs-selector-tag">Natural</span> <span class="hljs-selector-tag">Sorting</span>: <span class="hljs-selector-attr">[40, 103, 123, 135, 176, 555, 560, 589, 657, 864]</span> <br />
<span class="hljs-selector-tag">Before</span> <span class="hljs-selector-tag">Sorting</span>: <span class="hljs-selector-attr">[560, 864, 176, 657, 135, 103, 40, 123, 555, 589]</span> <br />
<span class="hljs-selector-tag">Reverse</span> <span class="hljs-selector-tag">Sorting</span>: <span class="hljs-selector-attr">[864, 657, 589, 560, 555, 176, 135, 123, 103, 40]</span> <br />
<span class="hljs-selector-tag">Sorted</span> <span class="hljs-selector-tag">Set</span>: <span class="hljs-selector-attr">[40, 103, 123, 135, 176, 555, 560, 589, 657, 864]</span> <br />
</code></pre>
      <h3><span id="java-set-common-operations">Java Set Common Operations</span></h3>
      <p>Most common operations performed on Java Set are add, addAll, clear, size etc. Below is a simple Java Set
            example showing common method usage.</p>
      
      <pre className='containers'><code class="hljs cs"><div class="re_clip-board" ></div>
import java.util.*; <br />
 <br />
<span class="keywords">public</span> <span class="keywords">class</span> <span class="hljs-title">SetCommonOperations</span>  <br />
&#123; <br />
<span class="hljs-function"><span class="keywords">public</span> <span class="keywords">static</span> <span class="keywords">void</span> <span class="hljs-title">main</span>(<span class="hljs-params">String args[]</span>)  <br />
</span>&#123; <br />
Set&lt;String&gt; vowels= <span class="keywords">new</span> HashSet&lt;&gt;(); <br />
       <br />
<span class="comment">//add example</span> <br />
vowels.<span class="keywords">add</span>(<span class="plain">"A"</span>); <br />
vowels.<span class="keywords">add</span>(<span class="plain">"E"</span>); <br />
vowels.<span class="keywords">add</span>(<span class="plain">"I"</span>); <br />
 <br />
<span class="comment">//We cannot insert elements based on index to a Set</span> <br />
System.<span class="keywords">out</span>.println(vowels); <br />
       <br />
Set&lt;String&gt; <span class="keywords">set</span> = <span class="keywords">new</span> HashSet&lt;&gt;(); <br />
<span class="keywords">set</span>.<span class="keywords">add</span>(<span class="plain">"O"</span>); <br />
<span class="keywords">set</span>.<span class="keywords">add</span>(<span class="plain">"U"</span>); <br />
 <br />
<span class="comment">//appending set elements to letters</span> <br />
vowels.addAll(<span class="keywords">set</span>); <br />
System.<span class="keywords">out</span>.println(vowels); <br />
 <br />
<span class="comment">//clear example to empty the set</span> <br />
<span class="keywords">set</span>.clear(); <br />
       <br />
<span class="comment">//size example</span> <br />
System.<span class="keywords">out</span>.println(<span class="plain">"letters set size = "</span> + vowels.size()); <br />
       <br />
vowels.clear(); <br />
vowels.<span class="keywords">add</span>(<span class="plain">"E"</span>); vowels.<span class="keywords">add</span>(<span class="plain">"E"</span>);vowels.<span class="keywords">add</span>(<span class="plain">"I"</span>); vowels.<span class="keywords">add</span>(<span class="plain">"O"</span>);<br />
System.<span class="keywords">out</span>.println(<span class="plain">"Given set contains E element or not? = "</span> + vowels.contains(<span class="plain">"E"</span>)); <br />
       <br />
&#125; <br />
&#125; <br />
</code></pre> <br />
      <p><strong>Output:-</strong></p>
      <pre className='output'><code class="hljs sql"><div class="re_clip-board" ></div> <br />
[A, E, I] <br />
[A, E, U, I, O] <br />
letters <span class="keywords">set</span> <span class="keywords">size</span> = <span class="plain">5</span> <br />
Given <span class="keywords">set</span> contains E <span class="keywords">element</span> <span class="keywords">or</span> <span class="keywords">not</span>? = <span class="hljs-literal">true</span> <br />
</code></pre>
      <h3><span id="java-set-iterator">Java Set Iterator</span></h3>
      <p>Below is a simple example showing how to iterate over Java Set.</p>
      <pre className='containers'><code class="hljs cs"><div class="re_clip-board" ></div>
import java.util.*; <br />
 <br />
<span class="keywords">public</span> <span class="keywords">class</span> <span class="hljs-title">SetIteratorExample</span> <br />
&#123; <br />
<span class="hljs-function"><span class="keywords">public</span> <span class="keywords">static</span> <span class="keywords">void</span> <span class="hljs-title">main</span>(<span class="hljs-params">String[] args</span>)  <br />
</span>&#123; <br />
 <br />
Set&lt;Integer&gt; <span class="keywords">set</span> = <span class="keywords">new</span> HashSet&lt;&gt;(); <br />
<span class="keywords">for</span>(<span class="keywords">int</span> i=<span class="plain">0</span>; i&lt;<span class="plain">5</span>; i++)  <br />
      <span class="keywords">set</span>.<span class="keywords">add</span>(i); <br />
       <br />
Iterator iterator = <span class="keywords">set</span>.iterator(); <br />
 <br />
<span class="comment">//simple iteration</span> <br />
<span class="keywords">while</span>(iterator.hasNext())&#123; <br />
      <span class="keywords">int</span> i = (<span class="keywords">int</span>) iterator.next(); <br />
      System.<span class="keywords">out</span>.print(i + <span class="plain">", "</span>); <br />
&#125; <br />
System.<span class="keywords">out</span>.println(<span class="plain">"\n"</span> + <span class="keywords">set</span>); <br />
 <br />
<span class="comment">//modification of set using iterator</span> <br />
iterator = <span class="keywords">set</span>.iterator(); <br />
<span class="keywords">while</span>(iterator.hasNext())&#123; <br />
      <span class="keywords">int</span> x = (<span class="keywords">int</span>) iterator.next(); <br />
      <span class="keywords">if</span>(x%<span class="plain">2</span> ==<span class="plain">0</span>) iterator.<span class="keywords">remove</span>(); <br />
&#125; <br />
System.<span class="keywords">out</span>.println(<span class="keywords">set</span>); <br />
       <br />
<span class="comment">//changing set structure while iterating</span> <br />
iterator = <span class="keywords">set</span>.iterator(); <br />
<span class="keywords">while</span>(iterator.hasNext())&#123; <br />
          <span class="comment">//ConcurrentModificationException here</span> <br />
      <span class="keywords">int</span> x = (<span class="keywords">int</span>) iterator.next();  <br />
      <span class="keywords">if</span>(x==<span class="plain">1</span>) <span class="keywords">set</span>.<span class="keywords">add</span>(<span class="plain">10</span>); <br />
&#125; <br />
&#125; <br />
&#125; <br />
</code></pre> <br />
      <h3><span id="java-set-to-stream">Java Set to Stream</span></h3>
      <p>Below is a simple example showing how to convert a Java Set to Stream and perform some operations as per our
            requirements.</p>
      <pre className='containers'><code class="hljs cpp"><div class="re_clip-board" ></div> <br />
<span class="keywords">import</span> java.util.*; <br />
 <br />
<span class="keywords">public</span> <span class="hljs-class"><span class="keywords">class</span> <span class="hljs-title">SetToStream</span> &#123;</span> <br />
 <br />
<span class="hljs-function"><span class="keywords">public</span> <span class="keywords">static</span> <span class="keywords">void</span> <span class="hljs-title">main</span><span class="hljs-params">(String[] args)</span> </span>&#123; <br />
Set&lt;String&gt; vowelsSet = <span class="keywords">new</span> HashSet&lt;&gt;(); <br />
<span class="comment">// add example</span> <br />
vowelsSet.add(<span class="plain">"a"</span>); <br />
vowelsSet.add(<span class="plain">"e"</span>); <br />
vowelsSet.add(<span class="plain">"i"</span>); <br />
vowelsSet.add(<span class="plain">"o"</span>); <br />
vowelsSet.add(<span class="plain">"u"</span>); <br />
       <br />
<span class="comment">//convert set to stream</span> <br />
vowelsSet.stream().forEach(System.out::println); <br />
&#125; <br />
&#125; <br />
</code></pre>
      <p><strong>Output:-</strong></p>
      <pre className='output'><code class="hljs nginx"><div class="re_clip-board" ></div>
<span class="hljs-attribute">a</span> <br/>
e <br/>
u <br/>
i <br/>
o <br/>
</code></pre>
     
</div>
        </div>
    )
}

export default Jva_set
